import MainClass from '../utils/mainClass.ts';
import { MAIN_CLASS_PARAMS } from '../utils/mainClass.ts';
import Slider from '../utils/slider.js';

class SuccessStoriesSlider extends MainClass {
	private slider: Slider;
	private isMobile: boolean;

	constructor( options: MAIN_CLASS_PARAMS ) {
		super( options );
		this.isMobile = window.innerWidth < 768;
		this.slider = new Slider( options.item );
	}
}

export default SuccessStoriesSlider;
